var _path, _rect;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#394149",
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Search") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.28571429,14.5714286 C3.26192539,14.5714286 0,11.3095032 0,7.28571429 C0,3.26192539 3.26192539,0 7.28571429,0 C11.3095032,0 14.5714286,3.26192539 14.5714286,7.28571429 C14.5714286,11.3095032 11.3095032,14.5714286 7.28571429,14.5714286 Z M7.28571429,13.1142857 C10.5047454,13.1142857 13.1142857,10.5047454 13.1142857,7.28571429 C13.1142857,4.06668317 10.5047454,1.45714286 7.28571429,1.45714286 C4.06668317,1.45714286 1.45714286,4.06668317 1.45714286,7.28571429 C1.45714286,10.5047454 4.06668317,13.1142857 7.28571429,13.1142857 Z",
    id: "Oval"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-28",
    transform: "translate(14.571429, 14.571429) scale(-1, 1) rotate(45.000000) translate(-14.571429, -14.571429) ",
    x: 13.7142857,
    y: 11.1428571,
    width: 1.71428571,
    height: 6.85714286
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.53e023328916568cfe36911f45aa8734.svg";
export { ForwardRef as ReactComponent };